import React, { ChangeEvent, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import { Box, Button, IconButton, Stack } from "@mui/material";
import { Delete } from "@mui/icons-material";
import * as messagesActions from "../../../../store/messages/actions";
import { fileCheck } from "../../../../services/formServiceFunctions";

type LoginIndependentFileUploadProps = {
  headline?: string;
  helperText?: string;
  files: File[];
  setFiles: (files: File[]) => void;
};

export default function LoginIndependentFileUpload({ headline, helperText, files, setFiles }: LoginIndependentFileUploadProps) {
  const [clearInput, setClearInput] = useState(0);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleFilesChange = (event: ChangeEvent<HTMLInputElement>) => {
    const fileCheckRes = fileCheck(event.target);
    if (fileCheckRes.hasError) {
      messagesActions.addMessage({ type: "error", text: fileCheckRes.errorMsg });
      return;
    }
    if (!event.target.files) {
      return;
    }

    setFiles(Array.from(event.target.files));
  };
  return (
    <React.Fragment key={clearInput}>
      {headline && <Typography variant={"h5"}>{headline}</Typography>}
      {helperText && <p>{helperText}</p>}
      <Box sx={{ display: "none" }}>
        <input ref={inputRef} accept="image/*, application/pdf" type="file" onChange={handleFilesChange} />
      </Box>
      <Stack direction="row" sx={{
        justifyContent: "flex-end"
      }}>
        {files.length < 1 && <Button component={"span"} onClick={() => inputRef.current?.click()}>Datei Auswählen</Button>}
      </Stack>
      {files.length > 0 && (
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "flex-end",
            alignItems: "center"
          }}>
          <Box sx={{ wordBreak: "break-all" }}>{files[0].name}</Box>
          <IconButton
            onClick={() => {
              setFiles([]);
              setClearInput(clearInput + 1);
            }}
          >
            <Delete />
          </IconButton>
        </Stack>
      )}
    </React.Fragment>
  );
}
